module.exports = __webpack_public_path__ + "static/media/laptop_icon.21863406.svg";